import GetVoIPGrotesqueItalic from '@/core/fonts/GetVoIPGrotesque-Italic.woff2';
import GetVoIPGrotesque from '@/core/fonts/GetVoIPGrotesque.woff2';
import InterItalic from '@/core/fonts/Inter-italic.var.woff2';
import InterRoman from '@/core/fonts/Inter-roman.var.woff2';
export const MuiCssBaseline = {
    styleOverrides: `
    @font-face {
      font-family: 'GetVoIP Grotesque';
      font-style: normal;
      font-weight: 400;
      font-display: block;
      src: local('GetVoIP'), local('GetVoIP Grotesque'), url(${GetVoIPGrotesque}) format('woff2');
    }

    @font-face {
      font-family: 'GetVoIPGrotesque-Italic';
      font-style: italic;
      font-weight: normal;
      font-display: block;
      src: url(${GetVoIPGrotesqueItalic}) format('woff2');
    }				

    @font-face {
      font-family: 'Inter var';
      font-weight: 100 900;
      font-display: swap;
      font-style: normal;
      font-named-instance: 'Regular';
      src: local('Inter'), local('Inter-Regular'), url(${InterRoman}) format('woff2');
    }
    @font-face {
      font-family: 'Inter var';
      font-weight: 100 900;
      font-display: swap;
      font-style: italic;
      font-named-instance: 'Italic';
      src: local('Inter'), local('Inter-Italic'), url(${InterItalic}) format('woff2');
    }				
  `,
};
